import { render, staticRenderFns } from "./AddProducto.vue?vue&type=template&id=52d14db9"
import script from "./AddProducto.vue?vue&type=script&lang=js"
export * from "./AddProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports